import { render, staticRenderFns } from "./PowerBIWebpart.vue?vue&type=template&id=8fa8bad2"
import script from "./PowerBIWebpart.ts?vue&type=script&lang=ts&external"
export * from "./PowerBIWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports